import { createElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ActionType } from '@mews-commander/enums';
import { createAction } from '@mews/framework';
import { SET_ASSOCIATE_BILL_DIALOG_BILL_OWNER_ID } from '../../../../../modules/billing/ducks/changeAssociatedAccount';
import { openDialog } from '../../../../../modules/dialog/reducer';
import { initializeChangeAssociatedAccount } from '../changeBillAssociatedAccount/initialize';
import { BillHeadingAction } from './types';

interface ActionProps {
    action: BillHeadingAction<ActionType.ChangeBillAssociatedAccount>;
    component: React.ElementType;
    close: () => void;
}

export const CHANGE_BILL_ASSOCIATED_ACCOUNT_DIALOG_NAME = 'changeBillAssociatedAccount';

export const ChangeBillAssociatedAccountAction = ({ action, component, close }: ActionProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(initializeChangeAssociatedAccount(action.billId));
    }, [action.billId, dispatch]);

    const onClick = () => {
        dispatch(
            createAction(SET_ASSOCIATE_BILL_DIALOG_BILL_OWNER_ID, action.billId, {
                scope: CHANGE_BILL_ASSOCIATED_ACCOUNT_DIALOG_NAME,
            })
        );
        dispatch(openDialog(CHANGE_BILL_ASSOCIATED_ACCOUNT_DIALOG_NAME));
        close();
    };

    return createElement(component, {
        title: action.text,
        icon: action.icon,
        onClick,
    });
};
